export default __webpack_public_path__ + "static/media/soulbrain_logo.5c3b3aaa.svg";